module.exports = __webpack_public_path__ + "img/abi发布.a9b42095.jpg";